import request from '@utils/request'
import store from '@store/index.js'

export function getTrainList() {
  return request({
    url: '/train/hospital',
    method: 'get',
  })
}

export function getTherapyDecsion({ user_type, hospitalType }) {
  const params = {
    user_type,
    hospitalType,
  }

  /**
   * train/cycles/?user_type={role}
   * param {user_type}
   */
  return request({
    url: '/train/cycles/',
    method: 'get',
    params,
  })
}

export function getCombination(cid) {
  return request({
    url: '/train/combination/' + cid,
    method: 'get',
  })
}

export function getAmblyopiaList() {
  return request({
    url: '/train/hospital',
    method: 'get',
  })
}
export function putHistory(temp) {
  return request({
    url: '/train/result',
    method: 'post',
    data: temp,
  })
}

export function getHistory(uid, query) {
  return request({
    url: '/train/results',
    method: 'get',
    params: query,
  })
}

export function delHistory(rid) {
  return request({
    url: '/train/result/' + rid,
    method: 'delete',
  })
}

export function _putHistory(basic, config, result) {
  console.log('basic', basic)
  console.log('config', config)
  console.log('result', result)
  let type = ''
  if (basic.type) {
    type = 'check'
  } else if (basic.tName) {
    type = 'train'
  }
  let obj = {
    name: basic.type || basic.tName,
    startTime: basic.startTime,
    settings: config,
    result: result,
  }
  let temp = {
    uid: store.getters.curPatient.uid,
    result: JSON.stringify(obj),
    type: type,
  }
  if (store.getters.curPatient.uid) {
    putHistory(temp)
      .then(res => {
        if (res.data.code !== 0) {
          console.log('检查结果保存失败！')
        }
      })
      .catch(err => {
        console.log(err)
      })
  }
}
